import get from 'lodash/get'
import { nanoid } from 'nanoid'

// eslint-disable-next-line import/prefer-default-export
export function formElementPropsGenerator({
  formName = `form-${nanoid()}`,
  labels = {},
  placeholders = {},
  ariaLabels = {},
  ...rest
} = {}) {
  return name => {
    const props = {
      ...rest,
      id: `${formName}-${name}`,
      name,
    }
    const label = get(labels, name)
    if (label !== undefined) props.label = label
    const placeholder = get(placeholders, name)
    if (placeholder !== undefined) props.placeholder = placeholder
    // A control with no visible label needs a name of its own. The placeholder
    // doubles as one where there is a placeholder; ariaLabels covers the fields
    // that show a value instead and would gain unwanted copy from a placeholder.
    const ariaLabel = get(ariaLabels, name)
    if (!label) {
      if (ariaLabel !== undefined) props['aria-label'] = ariaLabel
      else if (placeholder !== undefined) props['aria-label'] = placeholder
    }
    return props
  }
}
